/**
 * Checks if a value is not a boolean and returns the type accordingly.
 */
export function isNoBoolean<T>(a: T | boolean): a is Exclude<T, boolean> {
    return a !== false;
}
